import {
  apiService,
  Partner,
  PartnerVoucher,
  CreatePartnerRequest,
  UpdatePartnerRequest,
  GetPartnersResponse,
  GetPartnerResponse,
  CreatePartnerResponse,
  UpdatePartnerResponse,
  DeletePartnerResponse,
  GetAllPartnerVouchersParams,
  GetAllPartnerVouchersResponse,
  GetPartnerVouchersResponse,
  ImportPartnerVouchersResponse,
  RedeemPartnerVoucherResponse,
  PartnerLocation,
  GetPartnerLocationsResponse,
  ImportPartnerLocationsResponse,
  DeletePartnerLocationResponse,
} from "./api";

export class PartnersService {
  private static instance: PartnersService;

  private constructor() {}

  public static getInstance(): PartnersService {
    if (!PartnersService.instance) {
      PartnersService.instance = new PartnersService();
    }
    return PartnersService.instance;
  }

  public async getPartners(params?: {
    status?: string;
    name?: string;
  }): Promise<GetPartnersResponse> {
    return apiService.getPartners(params);
  }

  public async getPartner(id: string): Promise<GetPartnerResponse> {
    return apiService.getPartner(id);
  }

  public async createPartner(
    data: CreatePartnerRequest
  ): Promise<CreatePartnerResponse> {
    return apiService.createPartner(data);
  }

  public async updatePartner(
    id: string,
    data: UpdatePartnerRequest
  ): Promise<UpdatePartnerResponse> {
    return apiService.updatePartner(id, data);
  }

  public async deletePartner(id: string): Promise<DeletePartnerResponse> {
    return apiService.deletePartner(id);
  }

  public async getAllPartnerVouchers(
    params?: GetAllPartnerVouchersParams
  ): Promise<GetAllPartnerVouchersResponse> {
    return apiService.getAllPartnerVouchers(params);
  }

  public async getPartnerVouchers(
    partnerId: string,
    status?: string
  ): Promise<GetPartnerVouchersResponse> {
    return apiService.getPartnerVouchers(partnerId, status);
  }

  public async importPartnerVouchers(
    partnerId: string,
    file: File
  ): Promise<ImportPartnerVouchersResponse> {
    return apiService.importPartnerVouchers(partnerId, file);
  }

  public async redeemPartnerVoucher(
    partnerId: string,
    voucherId: string
  ): Promise<RedeemPartnerVoucherResponse> {
    return apiService.redeemPartnerVoucher(partnerId, voucherId);
  }

  public async getPartnerLocations(
    partnerId: string,
    params?: { status?: string; search?: string }
  ): Promise<GetPartnerLocationsResponse> {
    return apiService.getPartnerLocations(partnerId, params);
  }

  public async importPartnerLocations(
    partnerId: string,
    file: File
  ): Promise<ImportPartnerLocationsResponse> {
    return apiService.importPartnerLocations(partnerId, file);
  }

  public async deletePartnerLocation(
    partnerId: string,
    locationId: string
  ): Promise<DeletePartnerLocationResponse> {
    return apiService.deletePartnerLocation(partnerId, locationId);
  }
}

export const partnersService = PartnersService.getInstance();

export type { Partner, PartnerVoucher, PartnerLocation };
